import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/print.css'
import './styles/print-ledger.css'

createRoot(document.getElementById("root")!).render(<App />);
